/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export enum TypeLogo {
  White = 'white',
  Default = 'default',
  Isotipo = 'isotipo-plane',
};

export enum TypeOfTheme {
  Light = 'light',
  Dark = 'dark'
};

export enum SpaceSizes {
  Size8 = 8,
  Size16 = 16,
  Size24 = 24,
  Size32 = 32,
  Size40 = 40,
  Size48 = 48,
  Size56 = 56,
  Size64 = 64,
  Size72 = 72,
  Size80 = 80,
  Small = 'small', //8px
  Middle = 'middle', //16px
  Large = 'large', //24px
};

export enum PositionIcons {
  Start = 'start',
  End = 'end'
};

export enum TypeButton {
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
};

export enum UiStates {
  Default = 'default',
  Hover = 'hover',
  Active = 'active',
  Focused = 'focused',
  Disabled = 'disabled',
};

export enum SizeButton {
  Normal = 'default',
  Small = 'sm',
  XSmall = 'xs',
};

export enum TypeLoader {
  Default = 'default',
  Secondary = 'secondary',
};

export enum HtmlTypeButton {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
};

export enum CheckerActionType {
  Button = 'button',
  Group = 'group',
};

export enum AlertOptions {
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Default = 'default',
};

export enum BadgeType {
  Basic = 'basic',
  Dot = 'dot',
};

export enum InputType {
  Text = 'text',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Tel = 'tel',
  Date = 'date',
  Time = 'time',
  Datetime = 'datetime-local',
  File = 'file',
  Search = 'search',
};

export enum InputStyle {
  Primary = 'primary',
  Board = 'board',
};

export enum EventOptions {
  Focus = 'focus',
  Hover = 'hover',
};

export enum ActionStatus {
  Error = 'error',
  Success = 'success',
};

export enum TypeCard {
  Simple = 'simple',
  Company = 'company',
  User = 'user',
};

export enum TypeNotification {
  Invite = 'invite',
  Operation = 'operation',
  Alert = 'alert',
};

export enum ConfigMode {
  Table = 'table',
  Card = 'card',
};
